<!-- Categories Start -->
<div class="ct-categories">
    <!-- Category Start -->
    <div class="ct-category">
        <div class="ct-category-bg" style="background-image: url('assets/img1/pizza-2.png')"></div>
        <div class="ct-category-content">
            <div class="ct-category-content-inner">
                <div class="section-title-wrap section-header">
                    <h5 class="custom-primary">Pizza Menu</h5>
                    <h2 class="title">Notre Passion, Notre Patrimoine, Nos Pizzas </h2>
                    <p class="subtitle">
                        Un hommage savoureux à nos racines, où chaque ingrédient raconte une histoire de tradition et d'excellence culinaire, pour vous offrir une expérience gustative inoubliable à chaque bouchée                    </p>
                </div>
                <!-- Menu Start -->
                <div class="row">
                    <div class="col-lg-6" *ngFor="let item of pizzamenu">
                        <div class="ct-mini-menu-item">
                            <div class="ct-mini-menu-top">
                                <h5>{{item.title}}</h5>
                                <div class="ct-mini-menu-dots"></div>
                                <!-- <span class="custom-primary">{{item.price | number:'1.2-2'}}$</span> -->
                            </div>
                            <div class="ct-mini-menu-bottom">
                                <p>{{item.shortdesc}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Menu End -->
            </div>
        </div>
    </div>
    <!-- Category End -->
    <!-- Category Start -->
    <div class="ct-category">
        <div class="ct-category-content">
            <div class="ct-category-content-inner">
                <div class="section-title-wrap section-header">
                    <h5 class="custom-primary">Plats Menu</h5>
                    <h2 class="title">Quelqu'un a-t-il mentionné la cuisine méditerranéenne ?</h2>
                    <p class="subtitle">
                        Nos plats sont soigneusement préparés avec une sélection exquise d'ingrédients, mettant en vedette du riz, du couscous, des patates et bien plus encore, pour vous offrir une expérience culinaire riche en saveurs et en textures.                    </p>
                </div>
                <!-- Menu Start -->
                <div class="row">
                    <div class="col-lg-6" *ngFor="let item of platmenu">
                        <div class="ct-mini-menu-item">
                            <div class="ct-mini-menu-top">
                                <h5>{{item.title}}</h5>
                                <div class="ct-mini-menu-dots"></div>
                                <!-- <span class="custom-primary">{{item.price | number:'1.2-2'}}$</span> -->
                            </div>
                            <div class="ct-mini-menu-bottom">
                                <p>{{item.shortdesc}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Menu End -->
            </div>
        </div>
        <div class="ct-category-bg" style="background-image: url('assets/img1/shawrma.png')"></div>
    </div>
    <!-- Category End -->
    <div class="ct-category">
        <div class="ct-category-bg" style="background-image: url('assets/img1/makloub-2.jpg')"></div>
        <div class="ct-category-content">
            <div class="ct-category-content-inner">
                <div class="section-title-wrap section-header">
                    <h5 class="custom-primary">Sandwitch & Makloub Menu</h5>
                    <h2 class="title">Nos Sandwitch et Nos Makloub </h2>
                    <p class="subtitle">
                        Découvrez nos sandwichs et Makloubs, une célébration de nos traditions culinaires et de saveurs inoubliables à chaque bouchée                </div>
                <!-- Menu Start -->
                <div class="row">
                    <div class="col-lg-6" *ngFor="let item of MankloubAndSandwitchamenu">
                        <div class="ct-mini-menu-item">
                            <div class="ct-mini-menu-top">
                                <h5>{{item.title}}</h5>
                                <div class="ct-mini-menu-dots"></div>
                                <!-- <span class="custom-primary">{{item.price | number:'1.2-2'}}$</span> -->
                            </div>
                            <div class="ct-mini-menu-bottom">
                                <p>{{item.shortdesc}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Menu End -->
            </div>
        </div>
    </div>
    <!-- Category End -->
    <!-- Category Start -->
    <div class="ct-category">
        <div class="ct-category-content">
            <div class="ct-category-content-inner">
                <div class="section-title-wrap section-header">
                    <h5 class="custom-primary">Burger Menu</h5>
                    <h2 class="title">Nos Burgers</h2>
                    <p class="subtitle">Découvrez nos burgers croustillants et savoureux, prêts à satisfaire toutes les envies.</p>
                </div>
                <!-- Menu Start -->
                <div class="row">
                    <div class="col-lg-6" *ngFor="let item of burgerMenu">
                        <div class="ct-mini-menu-item">
                            <div class="ct-mini-menu-top">
                                <h5>{{item.title}}</h5>
                                <div class="ct-mini-menu-dots"></div>
                                <!-- <span class="custom-primary">{{item.price | number:'1.2-2'}}$</span> -->
                            </div>
                            <div class="ct-mini-menu-bottom">
                                <p>{{item.shortdesc}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Menu End -->
            </div>
        </div>
        <div class="ct-category-bg desktop-bg" style="background-image: url('assets/img1/menu-burger.jpg')"></div>
        <div class="ct-category-bg mobile-bg" style="background-image: url('assets/img1/burger-mobile.jpg')"></div>
    </div>
    <!-- Category End -->
</div>
<!-- Categories End -->